import { ReactElement, useEffect } from 'react'
import ReactDom from 'react-dom'

interface ModalProps {
	children: ReactElement
	isShowing: boolean
	callBack?: () => void
}

export function ModalComponent(props: ModalProps): ReactElement {
	useEffect(() => {
		const listner = function listner(e: KeyboardEvent): void {
			if (e.key === 'Escape' || e.key === 'Esc') {
				// e.preventDefault()
				// e.stopPropagation()
				if (props.callBack) props.callBack()
				// isShowing && toggle()
			}
		}

		window.addEventListener('keyup', listner)

		return () => {
			window.removeEventListener('keyup', listner)
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.isShowing])

	return (
		<>
			{props.isShowing
				? ReactDom.createPortal(
						<div className='modal-overlay'>
							<div className='modal-wrapper'>
								<div className='modal'>{props.children}</div>
							</div>
						</div>,
						document.body,
				  )
				: null}
		</>
	)
}

interface ModalHeaderProps {
	callBack: () => void
	title: string
}

export function ModalHeader({
	callBack,
	title,
}: ModalHeaderProps): ReactElement {
	return (
		<div className='modal-header'>
			{title || 'Brandtech'}
			<button
				className='modal-button-close'
				data-dismiss='modal'
				aria-label='Close'
				onClick={callBack}
			>
				&times;
			</button>
		</div>
	)
}

interface ModalBodyProps {
	children: ReactElement | string
}

export function ModalBody({ children }: ModalBodyProps): ReactElement {
	return <div className='modal-body'>{children}</div>
}
interface ModalFooterProps {
	children: ReactElement
}
export function ModalFooter({ children }: ModalFooterProps): ReactElement {
	return <div className='modal-footer'>{children}</div>
}
